import { Dispatch } from 'react';

import { VStack, Wrap } from '@chakra-ui/react';

import { TABLE_HEADERS } from '../ColumnComponents';

import MultiAutocomplete from './MultiAutocomplete';

import { useLienholders } from '../../../../hooks/useLienholders';
import { FiltersAction, FiltersActionKind, FiltersState } from '../../util';

interface Props {
  dispatch: Dispatch<FiltersAction>;
  filters: FiltersState;
  canSeeAIPayoffRequests: boolean;
}

const TableFilters = ({ dispatch, filters, canSeeAIPayoffRequests }: Props) => {
  const { options: lienholderOptions } = useLienholders();

  return (
    <VStack
      p={3}
      bgColor="babyBlueEyes"
      align="start"
      w="100%"
      borderTopLeftRadius={canSeeAIPayoffRequests ? 0 : 8}
      borderTopRightRadius={8}
    >
      <Wrap overflow="visible">
        <MultiAutocomplete
          placeholder={TABLE_HEADERS.LIENHOLDER}
          options={lienholderOptions}
          dispatch={dispatch}
          actionKind={FiltersActionKind.SET_LIENHOLDERS}
          value={filters.lienholders}
        />
      </Wrap>
    </VStack>
  );
};

export default TableFilters;
